// Zustand des Dialogs „Aufgabenliste importieren" (#1297).
//
// Eigenes Blatt-Modul (nur Signale) wie store/capture.ts: Auslöser — Befehlspalette,
// „+ Neu" im Projekt, Listenansicht, Schnellerfassung — öffnen den Dialog, ohne
// die Dialog-Komponente zu importieren. Gemountet wird er EINMAL in App.tsx.

import { signal } from "@preact/signals";
import type { TaskImportTarget } from "@juuplan/shared";

export interface TaskImportOpenOptions {
  /** Vorauswahl des Ziels. */
  target?: TaskImportTarget;
  /** Vorauswahl des Projekts (Ziel „Bestehendes Projekt"). */
  projectId?: number;
  /** Vorbelegung des Textfelds. */
  text?: string;
}

/** null = geschlossen. */
export const taskImportSig = signal<TaskImportOpenOptions | null>(null);

export function openTaskImport(opts: TaskImportOpenOptions = {}): void {
  taskImportSig.value = { ...opts };
}

export function closeTaskImport(): void {
  taskImportSig.value = null;
}
